/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Give_1Inputs */

const en_cp_lead_give_1 = /** @type {(inputs: Cp_Lead_Give_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 build night with ≥ 15 attendees`)
};

const id_cp_lead_give_1 = /** @type {(inputs: Cp_Lead_Give_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 build night dengan ≥ 15 peserta`)
};

/**
* | output |
* | --- |
* | "1 build night with ≥ 15 attendees" |
*
* @param {Cp_Lead_Give_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_give_1 = /** @type {((inputs?: Cp_Lead_Give_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Give_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_give_1(inputs)
	return en_cp_lead_give_1(inputs)
});